/**
 * RandomLoader — Valuo.pro
 * Picks a random organic loader on each mount.
 * Use instead of <Loader2 className="animate-spin" /> everywhere.
 */
import { useMemo } from "react";
import { ALL_LOADERS } from "@/components/organic-loaders/Showcase";

const VALUO_GOLD = "rgba(225, 196, 34, 0.5)";

export function RandomLoader({ size = 48, color = VALUO_GOLD, className = "" }) {
  const LoaderComponent = useMemo(() => {
    const idx = Math.floor(Math.random() * ALL_LOADERS.length);
    return ALL_LOADERS[idx];
  }, []);

  return (
    <div className={className} data-testid="organic-loader">
      <LoaderComponent size={size} color={color} />
    </div>
  );
}

export default RandomLoader;
